import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProvidersBillingRoutingModule } from './providers-billing-routing.module';
import { UnprocessedClaimsComponent } from './unprocessed-claims/unprocessed-claims.component';
import { ProcessedClaimsComponent } from './processed-claims/processed-claims.component';
import { PaymentsComponent } from './payments/payments.component';
import { DenialsAuditsComponent } from './denials-audits/denials-audits.component';
import { AgGridModule } from 'ag-grid-angular';
import { ProvidersBillingService } from './providers-billing-service.service';
import { FormsModule } from '@angular/forms';
import { UsersService } from '../users/users.service';
import { DirectivesModule } from 'app/directives/directives.module';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';
import { BatchDetailComponent } from './processed-claims/components/batch-detail/batch-detail.component';
import { BatchPayDetailComponent } from './payments/components/batch-pay-detail/batch-pay-detail.component';
import { EditReservationModule } from '../trip-reservations/edit-reservation/edit-reservation.module';
import { EOPButtonComponent } from '../A2-utils/grid-components/eop-button/eop-button.component';
import { ClaimButtonComponent } from '../A2-utils/grid-components/claim-button/claim-button.component';
import { BatchClaimButtonComponent } from '../A2-utils/grid-components/batch-claim-button/batch-claim-button.component';
import { ProgressBarModule } from 'app/utils/progress-bar/progress-bar.module';
import { RecalculateButtonModule } from '../A2-utils/recalculate-button/recalculate-button.module';
import { BooleanCheckComponent } from '../A2-utils/grid-components/boolean-check/boolean-check.component';
import { DenialsComponent } from './denials/denials.component';
import { ManifestModule } from '../A2-utils/manifest/manifest.module';
import { ApprovalTripModule } from '../trip-reservations/approval-trip/approval-trip.module';
import { TripManifestModule } from '../A2-utils/trip-manifest/trip-manifest.module';
import { DropdownProviderModule } from 'app/utils/dropdown-provider/dropdown-provider.module';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    ProvidersBillingRoutingModule,
    AgGridModule.withComponents([EOPButtonComponent, ClaimButtonComponent, BatchClaimButtonComponent, BooleanCheckComponent]),
    DirectivesModule,
    Trip2ThemeModule,
    EditReservationModule,
    ProgressBarModule,
    RecalculateButtonModule,
    ManifestModule,
    ApprovalTripModule,
    TripManifestModule,
    DropdownProviderModule
  ],
  declarations: [
    UnprocessedClaimsComponent,
    ProcessedClaimsComponent,
    PaymentsComponent,
    DenialsAuditsComponent,
    BatchDetailComponent,
    BatchPayDetailComponent,
    DenialsComponent],
  exports: [
    UnprocessedClaimsComponent,
    DenialsComponent,
    ProcessedClaimsComponent,
    PaymentsComponent
  ],
  providers: [
    ProvidersBillingService,
    UsersService
  ]
})
export class ProvidersBillingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/providers-billing/providers-billing.module.ts